import styled from "styled-components";

export const PartnersContainer = styled.div`
  width: 100%;
  padding: 60px 5%;
  box-sizing: border-box;
`;

export const PageTitle = styled.h1`
  text-align: center;
  margin: 0 0 50px;
  font-family: "Poppins", sans-serif;
  font-size: 42px;
  font-weight: 600;
  color: #000;

  @media (max-width: 767px) {
    font-size: 30px;
    margin-bottom: 35px;
  }
`;

export const PartnersGrid = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const PartnerCard = styled.div`
  width: 100%;
  min-height: 220px;
  padding: 30px;
  box-sizing: border-box;

  background: #fff;
  border-radius: 8px;

  text-align: left;

  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 1.6;

  @media (max-width: 767px) {
    padding: 22px;
  }
`;

export const PartnerLogo = styled.img`
  max-width: 130px;
  height: auto;
  object-fit: contain;
  margin-bottom: 8px;
`;

export const PartnerLink = styled.a`
  color: blue;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

export const PartnerDetails = styled.div`
  margin-top: 8px;
  color: #222;

  strong {
    font-weight: 700;
  }
`;
